module.exports = __webpack_public_path__ + "img/jaecoo_logo.b2218c2c.svg";